module.exports = __webpack_public_path__ + "img/plans_footer.8ff0ad66.png";